export const SHORT_DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;
export const LONG_DAY_NAMES = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"] as const;
export type LongDayNames = (typeof LONG_DAY_NAMES)[number];

export const INSTANT_DURATION = "P0Y0M0DT0H0M0S";

export const DATE_FORMAT_SHORT = "dd/MM/yy";
export const DATE_FORMAT = "yyy-MM-dd";
export const TIME_FORMAT_SHORT = "p";
